/**
 * Matches server `cloneDisplayName` in `taskClone.service.ts` so the confirmation
 * dialog shows the same name the new task will get after clone.
 */
export function previewCloneTaskName(
  originalName: string | null | undefined,
  sourceTaskLabel: string
): string {
  if (originalName && originalName.trim()) {
    const t = originalName.trim();
    if (/\(clone\)$/i.test(t)) return t;
    return `${t} (clone)`;
  }
  return `Clone of ${sourceTaskLabel}`;
}
